import { useId } from 'react';
import { Alert, Label, Select } from '@/shared/components';
import type { InvoicingMode } from '../types/security-admin.types';
import {
  INVOICING_MODE_OPTIONS,
  invoicingModeHelp,
  invoicingModeWarning,
} from '../utils/invoicingMode';

interface InvoicingModeFieldProps {
  id?: string;
  value: InvoicingMode;
  onChange: (mode: InvoicingMode) => void;
  onBlur?: () => void;
  productsCount: number;
  error?: string;
}

export function InvoicingModeField({
  id,
  value,
  onChange,
  onBlur,
  productsCount,
  error,
}: InvoicingModeFieldProps) {
  const fallbackId = useId();
  const fieldId = id ?? fallbackId;
  const helpId = `${fieldId}-help`;
  const warning = invoicingModeWarning(value, productsCount);

  return (
    <div className="space-y-2">
      <Label id={`${fieldId}-label`} htmlFor={fieldId}>
        Invoicing mode
      </Label>
      <Select
        id={fieldId}
        ariaLabelledBy={`${fieldId}-label`}
        ariaDescribedBy={helpId}
        options={INVOICING_MODE_OPTIONS}
        value={value}
        onChange={(next) => onChange(next as InvoicingMode)}
        onBlur={onBlur}
        error={!!error}
        hint={error}
      />
      <p id={helpId} className="text-sm text-mp-muted">
        {invoicingModeHelp(value)}
      </p>
      {warning && (
        <Alert variant="warning" role="status">
          {warning}
        </Alert>
      )}
    </div>
  );
}
